import React, { useContext } from 'react';
import styled from 'styled-components';
import Link from 'next/link';
import { useRouter } from 'next/router';
import useFlags from '@lib/hooks/useFlags';
import messageStripe from '@components/MessageStripe';
import LanguageContext from '@lib/contexts/languageContext';
import { isEnabledOnPage } from '@lib/utils';
import { UserContext } from '@lib/contexts/UserProvider';

const Anchor = styled.a`
  && {
    color: #fff;
    text-decoration: none;
  }
`;

const MessageStripe = styled(messageStripe)`
  position: sticky;
  top: 0;
  padding-left: 0;
  padding-right: 0;
`;

const ENABLED_PATHS = [
  { path: '/[lang]/playlists', exact: false },
  { path: '/[lang]/videos', exact: false },
  { path: '/[lang]', exact: true },
  { path: '/[lang]/me', exact: false },
];

const YearlyOffer = () => {
  const router = useRouter();
  const [flags] = useFlags();
  const lang = useContext(LanguageContext);
  const [currentUser] = useContext(UserContext);

  let showYearlyCampaign = true;
  if (
    // user not loaded yet
    currentUser === undefined ||
    // user doesnt have trial premium
    (currentUser?.subscription?.status === 'active' &&
      ['monthly', 'quarterly', 'yearly'].includes(
        currentUser?.subscription?.currentSubscriptionPlan?.planType
      )) ||
    // has wellness
    currentUser?.hasWellness
  ) {
    showYearlyCampaign = false;
  }

  const allowed_on_page = isEnabledOnPage(ENABLED_PATHS, router.pathname);
  if (
    !allowed_on_page ||
    !showYearlyCampaign ||
    !flags?.yearly_campaign_banners
  ) {
    return null;
  }

  return (
    <MessageStripe bg="#6C96A7" color="#fff" show>
      <Link href={`/${lang}/yearly`} legacyBehavior>
        <Anchor href={`/${lang}/yearly`}>
          {['en', 'fi'].includes(lang)
            ? 'Invest in your health. Choose between two amazing subscription offers. Click here!'
            : 'Investera i din hälsa med Yogobe. Välj mellan två fantastiska årserbjudanden (från 1599 SEK/år). Klicka här & läs mer!'}
        </Anchor>
      </Link>
    </MessageStripe>
  );
};

export default YearlyOffer;
